import React from 'react';
import { useNavigate } from 'react-router-dom';
import { EyeIcon } from 'lucide-react';
import { DataTable, Column } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { mockRequisitions } from '../data/mockData';
import { Requisition } from '../types';
export function RequisitionApprovalList() {
  const navigate = useNavigate();
  const columns: Column<Requisition>[] = [{
    key: 'reqNo',
    label: 'REQ No',
    render: r => <span className="font-medium text-indigo-600" data-id="element-1957">{r.reqNo}</span>
  }, {
    key: 'requestedBy',
    label: 'Originator'
  }, {
    key: 'department',
    label: 'Department'
  }, {
    key: 'reqFor',
    label: 'Req. For'
  }, {
    key: 'requiredDate',
    label: 'Required Date'
  }, {
    key: 'totalItems',
    label: 'Total Items'
  }, {
    key: 'status',
    label: 'Status',
    render: r => <StatusBadge status={r.status} data-id="element-1958" />
  }];
  return <div className="space-y-6 h-full flex flex-col" data-id="element-1959">
      <div className="flex items-center justify-between" data-id="element-1960">
        <div data-id="element-1961">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-1962">
            Requisition Approval
          </h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-1963">
            Review and approve internal requisitions.
          </p>
        </div>
      </div>

      <div className="flex-1" data-id="element-1964">
        <DataTable columns={columns} data={mockRequisitions.filter(r => r.status === 'Submitted' || r.status === 'Approved')} keyExtractor={item => item.id} searchPlaceholder="Search requisitions..." onRowClick={item => navigate(`/requisition-approval/${item.id}`)} actions={item => <div className="flex space-x-3 justify-end" data-id="element-1966">
              <button onClick={() => navigate(`/requisition-approval/${item.id}`)} className="inline-flex items-center px-2.5 py-1.5 border border-gray-300 shadow-sm text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50" data-id="element-1967">
                <EyeIcon className="h-3.5 w-3.5 mr-1" data-id="element-1968" /> Review
              </button>
            </div>} data-id="element-1965" />
      </div>
    </div>;
}